import { AUFTRAG_STATUS } from "../../utils/enums/AUFTRAG_STATUS";
import Select from "./Select";

const InputAuftragStatus = (props) => {
  const { ...attributes } = props || {};

  const options = Object.keys(AUFTRAG_STATUS).map(a => {
    const status = AUFTRAG_STATUS[a];
    return <option key={"status_" + status.KEY} value={status.KEY}>{status.BEZEICHNUNG + " (" + status.KEY + ")"}</option>;
  });
  options.unshift(<option key="default" value="">Keine Auswahl</option>);
  return <Select {...attributes}>{options}</Select>;
};
export default InputAuftragStatus;
